site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.inits.push('site.accessibility.init()');
